var _rect, _rect2, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAfterLogin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 88,
    height: 88,
    rx: 44,
    fill: "#E9F5F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 88,
    height: 88,
    rx: 44,
    stroke: "white",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M53.0003 50.2122C51.4563 49.8607 49.7685 49.667 48.0003 49.667C40.6365 49.667 34.667 53.0248 34.667 57.167C34.667 61.3092 34.667 64.667 48.0003 64.667C57.4793 64.667 60.2195 62.9698 61.0117 60.5003",
    stroke: "#1C274C",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0002 60.3333C62.6821 60.3333 65.6668 57.3486 65.6668 53.6667C65.6668 49.9848 62.6821 47 59.0002 47C55.3183 47 52.3335 49.9848 52.3335 53.6667C52.3335 57.3486 55.3183 60.3333 59.0002 60.3333Z",
    stroke: "#1C274C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7778 53.667L58.167 55.3337L61.2223 52.1855",
    stroke: "#1C274C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0002 44.6663C51.6821 44.6663 54.6668 41.6816 54.6668 37.9997C54.6668 34.3178 51.6821 31.333 48.0002 31.333C44.3183 31.333 41.3335 34.3178 41.3335 37.9997C41.3335 41.6816 44.3183 44.6663 48.0002 44.6663Z",
    stroke: "#1C274C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfterLogin);
export default __webpack_public_path__ + "static/media/after_login.7d2defa231fb6d95ad012e556b4de8b4.svg";
export { ForwardRef as ReactComponent };